import styled, { css } from "styled-components";
import Separator from "../../../components/Atoms/Separator";
import { tokens, media } from "../../../design/tokens";

interface AnnotationsContainerProps {
  hasNotes: boolean;
}

/*
 * Espelha Course/styles.ts — as duas telas compartilham o mesmo shell
 * (menu lateral | separador | conteudo) e os dois arquivos sao quase
 * identicos. A duplicacao nao foi resolvida aqui, so mantida em sincronia:
 * unificar as duas e refatoracao de estrutura, com risco proprio.
 *
 * Altura descontada do header em vez de `88vh` chutado, e empilhamento em
 * 980px (o valor de DESIGN.md, e o mesmo que o JS desta tela ja usa para
 * esconder o player) em vez de 768px.
 */
export const Container = styled.div`
  display: flex;
  align-items: stretch;

  height: calc(100vh - ${tokens.layout.headerHeight});

  ${media.upTo(tokens.breakpoint.md)} {
    flex-direction: column;
    align-items: stretch;

    height: auto;
    max-width: 100%;
    overflow-x: hidden;
  }
`;

export const StyledSeparator = styled(Separator)`
  height: 100% !important;

  ${media.upTo(tokens.breakpoint.md)} {
    display: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  height: 100%;
  min-height: 0;

  padding: 0 ${tokens.space.md};
`;

export const VideoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  flex: 1;
  min-height: 0;

  padding: ${tokens.space.xl};

  svg.close_video {
    display: none;
  }

  ${media.upTo(tokens.breakpoint.md)} {
    padding: 0;

    svg.close_video {
      z-index: 7;
      display: block;

      color: ${tokens.color.textWhite};
      fill: ${tokens.color.textWhite};
      font-size: 2rem;

      position: fixed;
      top: 1rem;
      right: 1rem;
    }
  }
`;

export const OverlayVideoModal = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  margin: 0 auto;

  ${media.upTo(tokens.breakpoint.md)} {
    background-color: ${tokens.color.stageBlack};

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    z-index: 6;
    padding: 0.5rem;
  }
`;

export const DriveMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  padding: 1rem;

  text-align: center;
  color: ${tokens.color.textWhite};

  a {
    color: ${tokens.color.marqueeGold};
    font-weight: bold;
  }
`;

/*
 * Aqui o desperdicio era maior que no Course: a tela ao vivo passa
 * `hasNotes={true}` fixo e nao tem anotacoes nenhuma — reservava 40% da
 * altura para um unico link de material de apoio, que muitas vezes nem
 * renderiza. Agora ocupa o que o conteudo pedir.
 */
export const AnnotationsContainer = styled.div<AnnotationsContainerProps>`
  display: flex;
  flex-direction: column;

  width: 100%;
  flex: 0 0 auto;
  min-height: 0;

  padding-bottom: ${tokens.space.md};

  ${(props) =>
    props.hasNotes &&
    css`
      max-height: 40%;
    `}

  &::-webkit-scrollbar-thumb {
    background: ${tokens.color.marqueeGold} !important;
  }

  h2 {
    margin-left: 1rem;
    color: ${tokens.color.textWhite};
  }

  h3.support_material {
    margin-left: 1rem;
    margin-top: 1rem;
    color: ${tokens.color.textWhite};

    a {
      margin-left: 0.5rem;
      color: ${tokens.color.marqueeGold};
    }
  }
`;
